import {
  AfterViewChecked,
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  Output,
  Renderer2,
  ViewChild,
} from "@angular/core";
import { FormBuilder, FormGroup, NgForm } from "@angular/forms";

import { filter, switchMap, take, tap } from "rxjs/operators";
import {
  createCustomEventObservable,
  urlShortener,
} from "src/app/core/constants/constants";
import { PaymentService } from "../../shared/services/payment.service";
import { Subscription, interval } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { Resource } from "src/app/core/coreResource";
import { ResponseCodes } from "../../shared/models/bankPaymentRes";
import { FinalTxnStatus } from "../../shared/models/transaction.status";
import { PaymentDetails } from "../../shared/models/paymentdetails";
import { Router } from "@angular/router";
import {
  DomSanitizer,
  SafeResourceUrl,
  SafeUrl,
} from "@angular/platform-browser";

@Component({
  selector: "app-visa-transactions",
  templateUrl: "./visa-transactions.component.html",
  styleUrls: ["./visa-transactions.component.css"],
  standalone: false,
})
export class VisaTransactionsComponent
  implements OnInit, AfterViewInit, AfterViewChecked, OnDestroy
{
  @Input() visaResponse: any;
  @ViewChild("testForm", { static: false }) testFormElement: any;

  private apiSubscription: Subscription;
  finalTxnStatus = new FinalTxnStatus();

  @Input() paymentDetails: PaymentDetails;
  @Output() emitErrorView: EventEmitter<any> = new EventEmitter();
  @Output() emitResponse: EventEmitter<any> = new EventEmitter();

  // testGroup: FormGroup;
  acsUrl: any;
  safeUrl: SafeResourceUrl;

  isLoaded: boolean = false;
  @ViewChild("getIframe", { static: false }) iframe: ElementRef;

  private iframeLoadCount = 0;

  constructor(
    private paymentService: PaymentService,
    private elementRef: ElementRef,
    private renderer: Renderer2,
    private router: Router,
    private sanitizer: DomSanitizer,
    private changeDetectorRef: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    // this.startApiCalls();
  }

  private listenForPostOtp(): void {
    const iframe =
      this.elementRef.nativeElement.querySelector("#secure3dFrame");
    if (!iframe) return;

    this.renderer.listen(iframe, "load", () => {
      this.iframeLoadCount++;

      if (this.iframeLoadCount === 4) {
        this.startApiCalls();
      }
    });
  }

  ngAfterViewInit(): void {
    if (this.visaResponse.method !== "GET") {
      this.testFormElement.nativeElement.submit();
      this.listenForPostOtp();
    }
    if (this.visaResponse.method === "GET") {
      this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
        this.visaResponse.acsUrl,
      );
    }
  }

  private startApiCalls() {
    this.apiSubscription = interval(3000) // Repeat every 3 seconds
      .pipe(
        take(12),
        switchMap(() =>
          this.paymentService.confirmTransfer(
            {
              transactionReference: this.visaResponse.transactionReference,
            },
            false,
            false, // Set is3ds to true for 3DS transactions
          ),
        ), // Replace with your API endpoint
      )
      .subscribe(
        (response) => {
          // Handle the API response

          if (response.responseCode === ResponseCodes.success) {
            // this.setTxnStatusMessage(response.responseCode);
            this.removeIframe();
            this.emitResponse.emit(response.responseCode);
          } else if (response.responseCode === ResponseCodes.error) {
            this.stopApiCalls();
            this.removeIframe();
            this.emitErrorView.emit(response.responseDescription);
          }
        },
        (error) => {
          // Handle the API error
        },
      );
  }

  private stopApiCalls() {
    if (this.apiSubscription) {
      this.apiSubscription.unsubscribe();
    }
  }

  removeIframe() {
    // fix selector — use # for id
    const iframeElement =
      this.elementRef.nativeElement.querySelector("#secure3dFrame");

    if (iframeElement) {
      this.renderer.removeChild(this.elementRef.nativeElement, iframeElement);
    }
  }

  ngAfterViewChecked(): void {
    this.changeDetectorRef.detectChanges();
  }

  ngOnDestroy(): void {
    this.stopApiCalls();
  }
}
